import React from 'react';
import { ImpersonationService } from '../services';

export const useImpersonationService = () => React.useMemo(() => new ImpersonationService(), []);
